export default __webpack_public_path__ + "static/media/si.85cb9ff2.svg";